// node-modules
import ScrollMagic from 'scrollmagic';

// constants
import { SELECTORS } from '@/scripts/constants';

// other
import { controller } from '@/components/_scrollmagic';

export default function headerToggle(container) {
  const header = container.querySelector('header');

  return new ScrollMagic.Scene({
    triggerElement: document.body,
    triggerHook: 'onLeave',
    offset: 30,
  })
    .setClassToggle(header, SELECTORS.active)
    .addTo(controller);
}



// WEBPACK FOOTER //
// ./components/_scrollmagic/scenes/header.js